import { set } from 'cerebral/operators'
import redirect from 'cerebral-module-router/redirect'
import isLoggedIn from '../../app/actions/isLoggedIn'

export default [
  isLoggedIn,
  {
    true: [set('state:client.currentPage', 'welcome'), redirect('/welcome')],
    false: [
      function hasSSO({ state, output }) {
        if(state.get('client.sso'))
          return output.true()

        return output.false()
      },
      {
        true: [
          function ssoRedirect({ state }){
              const url = state.get('client.sso.thirdPartyLoginURL')
              if(url)
                window.location.href = url
          }
        ],
        false: [
          set('state:client.currentPage', 'login')
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/setLogin.js